import FolderUploadModel from '@/Models/folderUploadModel';
import { folderFileUploadTypes, uploadArchiveTypes, UploadType } from '@/Types/Enums/uploadType';
import UploadModel from '@/Models/uploadModel';
import BaseUploadModel from '@/Models/baseUploadModel';

type FolderMapKey = `${string}:${UploadType}`;

export function getRootFolderNameFromRelativePath(path: string) {
  if (!path) {
    return null;
  }

  return path.substring(0, path.indexOf('/'));
}

export function isUploadBelongsToFolder(upload: BaseUploadModel) {
  return folderFileUploadTypes.some(t => t === upload.type);
}

export function isUploadArchive(upload: UploadModel) {
  return uploadArchiveTypes.some(t => t === upload.type);
}

function uploadsToFoldersMapReducer(folders: Map<FolderMapKey, UploadModel[]>, upload: UploadModel) {
  const folderName = getRootFolderNameFromRelativePath(upload.fileRelativePath);

  if (!folderName) {
    return folders;
  }

  const mapKey: FolderMapKey = `${folderName}:${upload.type}` as FolderMapKey;
  if (folders.has(mapKey)) {
    folders.get(mapKey).push(upload);
  } else {
    folders.set(mapKey, [upload]);
  }

  return folders;
}

export function groupUploadsToFolders(uploads: UploadModel[]): FolderUploadModel[] {
  const groupedUploads = uploads.reduce<Map<FolderMapKey, UploadModel[]>>(
    uploadsToFoldersMapReducer, new Map<FolderMapKey, UploadModel[]>);

  const result: FolderUploadModel[] = [];
  for (const groupKey of groupedUploads.keys()) {
    const uploadModels = groupedUploads.get(groupKey);
    const folderUploadModel = new FolderUploadModel(uploadModels);
    result.push(folderUploadModel);
  }

  return result;
}